import { Component, Input, OnInit } from '@angular/core';
import '../../../assets/js/windBarb.js';

declare var WindBarbArrowHandler: any;

@Component({
  selector: 'app-wind-barb',
  templateUrl: './wind-barb.component.html',
  styleUrls: ['./wind-barb.component.css'],
  standalone: false
})
export class WindBarbComponent implements OnInit {
  @Input() windSpeed: number;
  @Input() windDirection: number;
  @Input() divId: number;
  constructor() { }

  // ngOnInit(): void {
  //   let div = document.getElementById('windBarbArrow');
  //   div.id = 'windBarbArrow_' + this.divId;
  //   WindBarbArrowHandler.WindArrow(this.windSpeed, this.windDirection,  document.getElementById('windBarbArrow_'+this.divId), 50);
  // }
  ngOnInit(): void {
    let div = document.getElementById('windBarbArrow');
    div.id = 'windBarbArrow_' + this.divId;
    const svgContainerId = 'windBarbArrow_' + this.divId;
    const container = document.getElementById(svgContainerId);

    if (container) {
      WindBarbArrowHandler.WindArrow(this.windSpeed, this.windDirection, container, 50);
    } else {
      console.error('SVG container not found:', svgContainerId);
    }
  }


  onLocationChange(_windSpeed: number, _winDirection: number, _divId: number) {
    let div = document.getElementById('windBarbArrow_' + this.divId);
    div.id = 'windBarbArrow_' + _divId;
    WindBarbArrowHandler.WindArrow(_windSpeed, _winDirection, document.getElementById('windBarbArrow_' + _divId), 50);
  }

}
